export default "__VITE_ASSET__aa2bab89__"